import { API } from '../../../../config'
import { errorHandler } from '../../auth/errorAction'

export const unmountlistProvinceByCountry = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_PROVINCE'})
}

export const listProvinceByCountry = (value) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_PROVINCE' })
  const params = { 
    id: value 
  }
  API.GET('/province/getByCountryId', params).then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_PROVINCE_SUCCESS', 
      payload: {
        data: response.data,
        meta: response.meta
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DATA_MASTER_PROVINCE_FAILED' }), 
    ))
  })
}